import { mapActions } from "vuex";
import XLSX from 'xlsx';

export default {
    methods: {
        ...mapActions({
            saveAll: 'crudStore/saveAll',
            assignDataForm: 'crudStore/assignDataForm',
        }),
        async actualizarForm() {
            await this.resetDataForm({ state: 'servicios_nuevos' })
            await this.resetDataForm({ state: 'servicios_activos' })

            let totalAfl = 0
            let awaitfor = []

            for (let i = 0; i < this.dataMultiple[this.namePath].multiple_servicios.length; i++) {
                if (this.dataMultiple[this.namePath].multiple_servicios[i].check === 1 && this.dataMultiple[this.namePath].multiple_servicios[i].disabled === 0) {
                    let newValue = this.deepCopy(this.dataMultiple[this.namePath].multiple_servicios[i])
                    newValue.id = null
                    awaitfor.push(this.pushDataForm({ state: 'servicios_nuevos', data: this.deepCopy(newValue) }))
                    totalAfl = totalAfl + newValue.afiliacion
                }
                if (this.dataMultiple[this.namePath].multiple_servicios[i].check === 1 && this.dataMultiple[this.namePath].multiple_servicios[i].disabled === 1) {
                    let newValue = this.deepCopy(this.dataMultiple[this.namePath].multiple_servicios[i])
                    newValue.id = null
                    newValue.mes_periodo = this.fecha(this.dataForm[this.namePath].info_afiliacion.ingreso).proximoPago.mes
                    newValue.ano_periodo = this.fecha(this.dataForm[this.namePath].info_afiliacion.ingreso).proximoPago.ano
                    awaitfor.push(this.pushDataForm({ state: 'servicios_activos', data: this.deepCopy(newValue) }))
                    totalAfl = totalAfl + newValue.afiliacion
                }
            }
            await Promise.all(awaitfor)

            var name = this.dataForm[this.namePath].datos_afiliado.nombre1 + ' ' + this.dataForm[this.namePath].datos_afiliado.nombre2 + ' ' + this.dataForm[this.namePath].datos_afiliado.apellido1 + ' ' + this.dataForm[this.namePath].datos_afiliado.apellido2
            var re = /null/gi;

            const await00 = this.updateDataForm({ state: 'datos_afiliado/name', data: name.replace(re, ' ') })
            const await01 = this.updateDataForm({ state: 'afiliacion_registro/id_datos_razon', data: this.dataForm[this.namePath].info_afiliacion.id_datos_razon })
            const await02 = this.updateDataForm({ state: 'afiliacion_registro/id_datos_asesor', data: this.dataForm[this.namePath].info_afiliacion.id_datos_asesor })
            const await03 = this.updateDataForm({ state: 'afiliacion_registro/valor', data: totalAfl })
            const await04 = this.updateDataForm({ state: 'afiliacion_registro/servicios', data: this.dataForm[this.namePath].servicios_nuevos })

            await Promise.all([await00, await01, await02, await03, await04])

            await this.formToPost(['datos_afiliado', 'info_afiliacion', 'servicios_nuevos', 'servicios_activos', 'afiliacion_registro', 'afiliado_beneficiarios'])
            const await2 = this.updateDataForm({ state: 'servicios_activos', data: [] })
            const await3 = this.updateDataForm({ state: 'servicios_nuevos', data: [] })
            const await4 = this.resetDataForm({ state: 'datos_afiliado' })
            const await9 = this.updateDataForm({ state: 'afiliado_beneficiarios', data: [] })
            const await5 = this.updateCrud({ state: 'dataMultiple/' + this.namePath + '/multiple_servicios', data: this.predeterminados[this.namePath].multiple_servicios })
            var name = this.dataForm[this.namePath].datos_afiliado.nombre1 + ' ' + this.dataForm[this.namePath].datos_afiliado.nombre2 + ' ' + this.dataForm[this.namePath].datos_afiliado.apellido1 + ' ' + this.dataForm[this.namePath].datos_afiliado.apellido2
            var re = /null/gi;
            const await8 = this.updateDataForm({ state: 'datos_afiliado/name', data: name.replace(re, ' ') })
            const await6 = this.resetDataIndex();
            const await7 = this.saveNotify(false, 'Datos actualizados')

            await Promise.all([await2, await3, await4, await5, await6, await7, await8, await9])
        },
        async saveForm(event) {
            try {
                if (event.ftn !== undefined) {
                    switch (event.ftn) {
                        case 'afiliacionFtn':
                            if (this.dataForm[this.namePath].datos_afiliado.referido !== null) {
                                await this.updateDataPost({ state: 'tablaPost', data: ['info_ingresos', 'datos_afiliado', 'info_afiliacion', 'afiliacion_registro', 'servicios_nuevos', 'servicios_activos', 'afiliado_beneficiarios', 'descuentos_referido'] })
                            } else {
                                await this.updateDataPost({ state: 'tablaPost', data: ['info_ingresos', 'datos_afiliado', 'info_afiliacion', 'afiliacion_registro', 'servicios_nuevos', 'servicios_activos', 'afiliado_beneficiarios'] })
                            }
                            break;

                        case 'afiliacionGrupalFtn':


                            if (this.dataForm[this.namePath].datos_afiliado.referido !== null) {
                                await this.updateDataPost({ state: 'tablaPost', data: ['info_ingresos', 'datos_afiliado', 'info_afiliacion', 'afiliacion_registro', 'servicios_nuevos', 'servicios_activos', 'afiliado_beneficiarios', 'descuentos_referido'] })
                            } else {
                                await this.updateDataPost({ state: 'tablaPost', data: ['info_ingresos', 'datos_afiliado', 'info_afiliacion', 'afiliacion_registro', 'servicios_nuevos', 'servicios_activos', 'afiliado_beneficiarios'] })
                            }
                            break;

                        case 'tablePostGuardarFtn':
                            // se abre el modal de afiliaciongrupal
                            await this.updateGlobal({
                                state: 'openModal/modal',
                                data: { value: true, title: 'Registrar Afiliaciones Agrupadas', modal: 'AfiliacionGrupal', loaded: false, size: 'md' }
                            })
                            return true
                            break

                        case 'guardarFtn':
                            // resetea servicios nuevos y asigna los check de dataMultiple a servicios_nuevos y asigno servicios_Activos
                            let totalAfl = 0
                            let await01 = this.resetDataForm({ state: 'servicios_nuevos' })
                            let await02 = this.resetDataForm({ state: 'servicios_activos' })

                            await Promise.all([await01, await02])

                            let awaitfor = []

                            for (let i = 0; i < this.dataMultiple[this.namePath].multiple_servicios.length; i++) {
                                if (this.dataMultiple[this.namePath].multiple_servicios[i].check === 1 && this.dataMultiple[this.namePath].multiple_servicios[i].disabled === 0) {
                                    let newValue = this.deepCopy(this.dataMultiple[this.namePath].multiple_servicios[i])
                                    newValue.id = null
                                    totalAfl = totalAfl + this.dataMultiple[this.namePath].multiple_servicios[i].afiliacion
                                    awaitfor.push(this.pushDataForm({ state: 'servicios_nuevos', data: newValue }))
                                }
                                if (this.dataMultiple[this.namePath].multiple_servicios[i].check === 1 && this.dataMultiple[this.namePath].multiple_servicios[i].disabled === 1) {
                                    totalAfl = totalAfl + this.dataMultiple[this.namePath].multiple_servicios[i].afiliacion
                                    let newValue = this.deepCopy(this.dataMultiple[this.namePath].multiple_servicios[i])
                                    newValue.id = null
                                    newValue.mes_periodo = this.fecha(this.dataForm[this.namePath].info_afiliacion.ingreso).proximoPago.mes
                                    newValue.ano_periodo = this.fecha(this.dataForm[this.namePath].info_afiliacion.ingreso).proximoPago.ano
                                    awaitfor.push(await this.pushDataForm({ state: 'servicios_activos', data: newValue }))
                                }
                            }

                            await Promise.all(awaitfor)

                            // se actualizan datos de info_Afiliacion y afiliacion_registro
                            let info_afiliacion = {
                                id_list_users: this.user.id,
                                fecha: this.fecha().fecha.minHoy,
                                salariobase: this.dataForm[this.namePath].info_afiliacion.salario,
                            }

                            const await1 = this.assignDataForm({ state: 'info_afiliacion', data: info_afiliacion })

                            let afiliacion_registro = {
                                valor: totalAfl,
                                fecha: this.fecha().fecha.minHoy,
                                id_datos_razon: this.dataForm[this.namePath].info_afiliacion.id_datos_razon,
                                id_datos_asesor: this.dataForm[this.namePath].info_afiliacion.id_datos_asesor,
                                servicios: this.dataForm[this.namePath].servicios_nuevos
                            }

                            const await2 = this.assignDataForm({ state: 'afiliacion_registro', data: afiliacion_registro })

                            var name = this.dataForm[this.namePath].datos_afiliado.nombre1 + ' ' + this.dataForm[this.namePath].datos_afiliado.nombre2 + ' ' + this.dataForm[this.namePath].datos_afiliado.apellido1 + ' ' + this.dataForm[this.namePath].datos_afiliado.apellido2
                            var re = /null/gi;

                            let datos_afiliado = {
                                name: name.replace(re, ' '),
                                id_list_estado: 1
                            }

                            if (this.datosAsesor !== null) {
                                if (_.findIndex(this.lists.datos_afiliado, { id: this.dataForm[this.namePath].datos_afiliado.id, documento: this.dataForm[this.namePath].datos_afiliado.documento }) === -1) {
                                    datos_afiliado = {
                                        name: name.replace(re, ' '),
                                        id_list_estado: 1,
                                        id: null
                                    }
                                }
                            }

                            const await3 = this.assignDataForm({ state: 'datos_afiliado', data: datos_afiliado })
                            const await4 = this.updateDataPost({ state: 'route', data: 'save_all' })
                            const await6 = this.updateDataPost({ state: 'tablaDelete', data: [] })

                            let descuentos_referidos = {}
                            if (this.dataForm[this.namePath].datos_afiliado.referido !== null) {
                                descuentos_referidos.id = null
                                descuentos_referidos.referido = { name: name.replace(re, ' '), documento: this.dataForm[this.namePath].datos_afiliado.documento }
                                descuentos_referidos.id_datos_afiliado = this.dataForm[this.namePath].datos_afiliado.referido.id
                                descuentos_referidos.id_info_afiliacion = null,
                                    descuentos_referidos.descuento = this.dataForm[this.namePath].descuentos_referido.descuento

                                this.updateDataForm({ state: 'descuentos_referido', data: descuentos_referidos })
                                await this.updateDataPost({ state: 'tablaPost', data: ['datos_afiliado', 'info_afiliacion', 'afiliacion_registro', 'servicios_nuevos', 'servicios_activos', 'afiliado_beneficiarios', 'descuentos_referido'] })
                            } else {
                                await this.updateDataPost({ state: 'tablaPost', data: ['datos_afiliado', 'info_afiliacion', 'afiliacion_registro', 'servicios_nuevos', 'servicios_activos', 'afiliado_beneficiarios'] })
                            }
                            // se configura el dataPost	

                            await Promise.all([await1, await2, await3, await4, await6])

                            if (event.save === false) {
                                await this.updateDataPost({ state: 'data', data: [] })
                            }

                            // se abre el modal de afiliacion si se esta guardando
                            if (event.save === false && this.dataIndex[this.namePath] === false) {
                                await this.updateGlobal({
                                    state: 'openModal/modal',
                                    data: { value: true, title: 'Registrar Afiliación', modal: 'Afiliacion', loaded: false, size: 'md' }
                                })
                                return true
                            }

                            break;

                    }
                }

                let dataSave = await this.save(event.save, event.savePost)

                if (event.ftn !== undefined) {
                    let idFicha = this.dataForm[this.namePath].datos_afiliado.id
                    switch (event.ftn) {
                        case 'guardarFtn':
                            if (event.save === true) {
                                const await12 = this.saveNotify(false, 'Agrupado con éxito', false, false)
                                const await13 = this.updateDataForm({ state: 'servicios_activos', data: [] })
                                const await14 = this.updateDataForm({ state: 'servicios_nuevos', data: [] })
                                const await15 = this.resetDataForm({ state: 'datos_afiliado' })
                                const await16 = this.updateDataForm({ state: 'info_afiliacion/observacion', data: null })
                                await Promise.all([await12, await13, await14, await15, await16])
                            } else {
                                const await16 = this.resetDataForm()
                                const await17 = this.onInit()
                                await Promise.all([await16, await17])
                            }
                            break;
                        case 'afiliacionFtn':
                            if (this.dataForm[this.namePath].datos_afiliado.id === null || this.dataForm[this.namePath].datos_afiliado.id === '') {
                                idFicha = dataSave.ids.datos_afiliado
                            }

                            window.open(this.url + '/api/pdf/ficha?id=' + idFicha.toString() + '&token=' + this.token, '_blank')
                            window.open(this.url + '/api/pdf/registro?id=' + dataSave.ids.info_ingresos.toString() + '&token=' + this.token, '_blank')
                            if (event.excell) {
                                let dataToExport = []
                                let dataPostArray = this.dataForm[this.namePath]
                                if (dataPostArray.datos_afiliado !== undefined) {
                                    let epsExcell = ''
                                    let riesgoExcell = ''
                                    let ccfExcell = ''
                                    let afpExcell = ''
                                    let trasladoExcell = ''
                                    let otrosExcell = ''
                                    let afiliacionExcell = 0
                                    let valorExcell = 0
                                    for (let j = 0; j < dataPostArray.servicios_nuevos.length; j++) {
                                        valorExcell = dataPostArray.servicios_nuevos[j].valor
                                        afiliacionExcell = dataPostArray.servicios_nuevos[j].afiliacion
                                        if (dataPostArray.servicios_nuevos[j].name === 'Eps') {
                                            epsExcell = this.gettersDatalist('list_eps', dataPostArray.servicios_nuevos[j].id_list)[0].name
                                        } else if (dataPostArray.servicios_nuevos[j].name === 'Riesgo') {
                                            riesgoExcell = dataPostArray.servicios_nuevos[j].id_list
                                        } else if (dataPostArray.servicios_nuevos[j].name === 'Ccf') {
                                            ccfExcell = this.gettersDatalist('list_ccf', dataPostArray.servicios_nuevos[j].id_list)[0].name
                                        } else if (dataPostArray.servicios_nuevos[j].name === 'Afp') {
                                            afpExcell = this.gettersDatalist('list_afp', dataPostArray.servicios_nuevos[j].id_list)[0].name
                                        } else if (dataPostArray.servicios_nuevos[j].name === 'Traslado') {
                                            trasladoExcell = this.gettersDatalist('list_eps', dataPostArray.servicios_nuevos[j].id_list)[0].name
                                        } else {
                                            otrosExcell = otrosExcell + ' ' + dataPostArray.servicios_nuevos[j].name
                                        }
                                    }
                                    for (let j = 0; j < dataPostArray.servicios_activos.length; j++) {
                                        valorExcell = dataPostArray.servicios_activos[j].valor
                                        afiliacionExcell = dataPostArray.servicios_activos[j].afiliacion
                                    }

                                    let datosrazon = this.gettersDatalist('datos_razon', dataPostArray.info_afiliacion.id_datos_razon)[0]
                                    dataToExport.push([this.gettersDatalist('list_documento', dataPostArray.datos_afiliado.id_list_documento)[0].name, dataPostArray.datos_afiliado.documento.toString(), dataPostArray.datos_afiliado.nombre1, dataPostArray.datos_afiliado.nombre2, dataPostArray.datos_afiliado.apellido1, dataPostArray.datos_afiliado.apellido2, dataPostArray.datos_afiliado.nacimiento, dataPostArray.datos_afiliado.direccion, dataPostArray.datos_afiliado.ciudad, dataPostArray.datos_afiliado.telefonos, dataPostArray.datos_afiliado.email, this.gettersDatalist('datos_asesor', dataPostArray.info_afiliacion.id_datos_asesor)[0].name, datosrazon.name, this.gettersDatalist('list_documento', datosrazon.id_list_documento)[0].name, datosrazon.dv, dataPostArray.info_afiliacion.cargo, dataPostArray.info_afiliacion.salario, dataPostArray.info_afiliacion.ingreso, epsExcell, this.gettersDatalist('list_arl', datosrazon.id_list_arl)[0].name, riesgoExcell, ccfExcell, afpExcell, trasladoExcell, otrosExcell, afiliacionExcell, valorExcell])
                                }

                                let datae = XLSX.utils.json_to_sheet(dataToExport)
                                datae['A1'].v = 'Tipo'
                                datae['B1'].v = 'Documento'
                                datae['C1'].v = 'Nombre1'
                                datae['D1'].v = 'Nombre2'
                                datae['E1'].v = 'Apellido1'
                                datae['F1'].v = 'Apellido2'
                                datae['G1'].v = 'Nacimiento'
                                datae['H1'].v = 'Dirección'
                                datae['I1'].v = 'Ciudad'
                                datae['J1'].v = 'Telefonos'
                                datae['K1'].v = 'Email'
                                datae['L1'].v = 'Asesor'
                                datae['M1'].v = 'Razon Social'
                                datae['N1'].v = 'CC/NI'
                                datae['O1'].v = 'DV'
                                datae['P1'].v = 'Cargo'
                                datae['Q1'].v = 'Salario'
                                datae['R1'].v = 'Inicio Labores.'
                                datae['S1'].v = 'Eps'
                                datae['T1'].v = 'Arl'
                                datae['U1'].v = 'Riesgo'
                                datae['V1'].v = 'Ccf'
                                datae['W1'].v = 'Afp'
                                datae['X1'].v = 'Traslado'
                                datae['Y1'].v = 'Otros servicios'
                                datae['Z1'].v = 'Afiliación'
                                datae['AA1'].v = 'Valor'
                                const workbook = XLSX.utils.book_new()
                                const filename = 'afiliacion' + this.fecha().fecha.hoy
                                XLSX.utils.book_append_sheet(workbook, datae, filename)
                                XLSX.writeFile(workbook, `${filename}.xlsx`)
                            }
                            const await18 = this.resetDataForm()
                            const await19 = this.onInit()
                            await Promise.all([await18, await19])
                            break;
                        case 'afiliacionGrupalFtn':
                            if (this.dataForm[this.namePath].datos_afiliado.id === null || this.dataForm[this.namePath].datos_afiliado.id === '') {
                                idFicha = dataSave.ids.datos_afiliado
                            }

                            window.open(this.url + '/api/pdf/ficha?id=' + idFicha.toString() + '&token=' + this.token, '_blank')
                            window.open(this.url + '/api/pdf/registro?id=' + dataSave.ids.info_ingresos.toString() + '&token=' + this.token, '_blank')

                            if (event.excell) {
                                let dataToExport = []
                                let dataPostArray = this.dataPost[this.namePath].data
                                for (let i = 0; i < dataPostArray.length; i++) {
                                    if (dataPostArray[i].datos_afiliado !== undefined) {
                                        let epsExcell = ''
                                        let riesgoExcell = ''
                                        let ccfExcell = ''
                                        let afpExcell = ''
                                        let trasladoExcell = ''
                                        let otrosExcell = ''
                                        let afiliacionExcell = 0
                                        let valorExcell = 0
                                        for (let j = 0; j < dataPostArray[i].servicios_nuevos.length; j++) {
                                            valorExcell = dataPostArray[i].servicios_nuevos[j].valor
                                            afiliacionExcell = dataPostArray[i].servicios_nuevos[j].afiliacion
                                            if (dataPostArray[i].servicios_nuevos[j].name === 'Eps') {
                                                epsExcell = this.gettersDatalist('list_eps', dataPostArray[i].servicios_nuevos[j].id_list)[0].name
                                            } else if (dataPostArray[i].servicios_nuevos[j].name === 'Riesgo') {
                                                riesgoExcell = dataPostArray[i].servicios_nuevos[j].id_list
                                            } else if (dataPostArray[i].servicios_nuevos[j].name === 'Ccf') {
                                                ccfExcell = this.gettersDatalist('list_ccf', dataPostArray[i].servicios_nuevos[j].id_list)[0].name
                                            } else if (dataPostArray[i].servicios_nuevos[j].name === 'Afp') {
                                                afpExcell = this.gettersDatalist('list_afp', dataPostArray[i].servicios_nuevos[j].id_list)[0].name
                                            } else if (dataPostArray[i].servicios_nuevos[j].name === 'Traslado') {
                                                trasladoExcell = this.gettersDatalist('list_eps', dataPostArray[i].servicios_nuevos[j].id_list)[0].name
                                            } else {
                                                otrosExcell = otrosExcell + ' ' + dataPostArray[i].servicios_nuevos[j].name
                                            }
                                        }
                                        for (let j = 0; j < dataPostArray[i].servicios_activos.length; j++) {
                                            valorExcell = dataPostArray[i].servicios_activos[j].valor
                                            afiliacionExcell = dataPostArray[i].servicios_activos[j].afiliacion
                                        }

                                        let datosrazon = this.gettersDatalist('datos_razon', dataPostArray[i].info_afiliacion.id_datos_razon)[0]
                                        dataToExport.push([this.gettersDatalist('list_documento', dataPostArray[i].datos_afiliado.id_list_documento)[0].name, dataPostArray[i].datos_afiliado.documento.toString(), dataPostArray[i].datos_afiliado.nombre1, dataPostArray[i].datos_afiliado.nombre2, dataPostArray[i].datos_afiliado.apellido1, dataPostArray[i].datos_afiliado.apellido2, dataPostArray[i].datos_afiliado.nacimiento, dataPostArray[i].datos_afiliado.direccion, dataPostArray[i].datos_afiliado.ciudad, dataPostArray[i].datos_afiliado.telefonos, dataPostArray[i].datos_afiliado.email, this.gettersDatalist('datos_asesor', dataPostArray[i].info_afiliacion.id_datos_asesor)[0].name, datosrazon.name, this.gettersDatalist('list_documento', datosrazon.id_list_documento)[0].name, datosrazon.dv, dataPostArray[i].info_afiliacion.cargo, dataPostArray[i].info_afiliacion.salario, dataPostArray[i].info_afiliacion.ingreso, epsExcell, this.gettersDatalist('list_arl', datosrazon.id_list_arl)[0].name, riesgoExcell, ccfExcell, afpExcell, trasladoExcell, otrosExcell, afiliacionExcell, valorExcell])
                                    }
                                }
                                let datae = XLSX.utils.json_to_sheet(dataToExport)
                                datae['A1'].v = 'Tipo'
                                datae['B1'].v = 'Documento'
                                datae['C1'].v = 'Nombre1'
                                datae['D1'].v = 'Nombre2'
                                datae['E1'].v = 'Apellido1'
                                datae['F1'].v = 'Apellido2'
                                datae['G1'].v = 'Nacimiento'
                                datae['H1'].v = 'Dirección'
                                datae['I1'].v = 'Ciudad'
                                datae['J1'].v = 'Telefonos'
                                datae['K1'].v = 'Email'
                                datae['L1'].v = 'Asesor'
                                datae['M1'].v = 'Razon Social'
                                datae['N1'].v = 'CC/NI'
                                datae['O1'].v = 'DV'
                                datae['P1'].v = 'Cargo'
                                datae['Q1'].v = 'Salario'
                                datae['R1'].v = 'Inicio Labores.'
                                datae['S1'].v = 'Eps'
                                datae['T1'].v = 'Arl'
                                datae['U1'].v = 'Riesgo'
                                datae['V1'].v = 'Ccf'
                                datae['W1'].v = 'Afp'
                                datae['X1'].v = 'Traslado'
                                datae['Y1'].v = 'Otros servicios'
                                datae['Z1'].v = 'Afiliación'
                                datae['AA1'].v = 'Valor'
                                const workbook = XLSX.utils.book_new()
                                const filename = 'afiliacion' + this.fecha().fecha.hoy
                                XLSX.utils.book_append_sheet(workbook, datae, filename)
                                XLSX.writeFile(workbook, `${filename}.xlsx`)
                            }

                            const await24 = this.resetDataForm()
                            const await25 = this.onInit()
                            await Promise.all([await24, await25])
                            break;
                    }
                }

                const await30 = this.resetDataIndex()
                const await31 = this.resetGlobal({ state: 'openModal' })
                const await32 = this.updateCrud({ state: 'dataMultiple/' + this.namePath + '/multiple_servicios', data: this.predeterminados[this.namePath].multiple_servicios })
                const await33 = this.resetGlobal({ state: 'saveConfig/capa' })
                const await35 = this.resetGlobal({ state: 'saveConfig/saveloading' })
                const await34 = this.updateDataForm({ state: 'afiliado_beneficiarios', data: [] })

                await Promise.all([await30, await31, await32, await33, await34, await35])
                if (!event.save) {
                    await this.resetDataPost({ state: 'data' })
                }

                return true

            } catch (e) {
                console.log(e)
            }
        },
    },
}